import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { airSourceHeatPumpsLp } from "@/content/landing/air-source-heat-pumps";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { SERVICE_PAGE_OG_IMAGES } from "@/lib/service-page-og-images";

const LpAirSourceHeatPumpsPage = lazyNamed(
  () => import("@/components/landing/lp-air-source-heat-pumps"),
  "LpAirSourceHeatPumps",
);

const PATH = "/air-source-heat-pumps";
const TITLE = "Air Source Heat Pumps South Wales | MCS Certified | CRS Energy";
const DESCRIPTION =
  "MCS certified air source heat pump design, install and commissioning across South Wales. Full heat-loss survey, manufacturer-backed warranty, coordinated retrofit. Free assessment.";

export const Route = createFileRoute("/air-source-heat-pumps")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      image: SERVICE_PAGE_OG_IMAGES[PATH],
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: "Air Source Heat Pumps",
        description: DESCRIPTION,
        serviceType: "Air Source Heat Pumps",
        url: `${SITE.url}${PATH}`,
        image: SERVICE_PAGE_OG_IMAGES[PATH],
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: airSourceHeatPumpsLp.faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: LpAirSourceHeatPumpsPage,
});
